import React from 'react';
import { FieldValidator } from 'final-form';
import { RenderDropdown } from 'forms';
import { Validator } from 'forms/validators/types';
import { Field } from 'react-final-form';
import { AREA_STRUCTURE_DROPDOWN_OPTIONS } from './constants';

interface Props {
    name: string;
    validate?: FieldValidator<Validator>;
    label?: string;
    placeholder?: string;
    multiple?: boolean;
    disabled?: boolean;
    clearable?: boolean;
}

export default function AreaStructureDropdown(
    props: Props
): React.ReactElement {
    const {
        name,
        validate,
        label = '',
        placeholder = '',
        multiple,
        disabled = false,
        clearable = false
    } = props;

    const options = AREA_STRUCTURE_DROPDOWN_OPTIONS;

    return (
        <Field
            component={RenderDropdown as any}
            subscription={{
                value: true,
                touched: true,
                error: true
            }}
            name={name}
            validate={validate}
            label={label}
            placeholder={placeholder}
            fluid
            search
            selection
            clearable={clearable}
            selectOnBlur={false}
            multiple={multiple}
            options={options}
            disabled={disabled}
        />
    );
}
